import styled from 'styled-components';
import { FormControlSizes } from '../../Form/types';
import { IconButton } from './IconButton';

export const TabIconButton = styled(IconButton)`
  border-radius: 0;
  margin-left: 1px;
  color: ${({ ghost }) => (ghost ? 'var(--colorTextDefault)' : 'var(--colorTextImportant)')};

  &:hover {
    color: var(--colorTextImportant);
  }
`;
TabIconButton.defaultProps = {
  size: FormControlSizes.Small,
  ghost: true,
};
